import * as React from "react"

import { cn } from "@/lib/utils"

// Layout follows concept2 prototype (docs/studio/design-concept2/src/primitives.jsx Field).
// Stack column with gap 6 = gap-1.5; label text-[13px] font-medium; error text-xs (12 px).
// `*` for required is rendered in destructive color, ml-1.
//
// Composition pattern: <Field label="..." error="..."><Input /></Field>
// — control element is passed as child, label/error are slots.
export interface FieldProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Visible label rendered above the control. */
  label?: React.ReactNode
  /** When true, an asterisk (`*`) is shown next to the label. */
  required?: boolean
  /** Error message rendered below the control in destructive color. */
  error?: React.ReactNode
}

const Field = React.forwardRef<HTMLDivElement, FieldProps>(
  ({ className, label, required, error, children, ...props }, ref) => (
    <div
      ref={ref}
      className={cn("flex flex-col gap-1.5", className)}
      {...props}
    >
      {label ? (
        <label className="text-[13px] font-medium text-foreground">
          {label}
          {required ? (
            <span className="ml-1 text-destructive" aria-hidden="true">
              *
            </span>
          ) : null}
        </label>
      ) : null}
      {children}
      {error ? (
        <div className="text-xs text-destructive" role="alert">
          {error}
        </div>
      ) : null}
    </div>
  )
)
Field.displayName = "Field"

export { Field }
